<template>
  <apexchart 
      width="100%"
      height="200"
      :type="chartType"
      :options="options"
      :series="series"
      ref="apexchart-simple"
    ></apexchart>
</template>


<script>
import * as moment from "moment";
import ApexchartHelper from "@/helpers/settings/apexchart";
import VueApexCharts from "vue-apexcharts";
import ApexCharts from "apexcharts";

export default {
  name: "LLChartSimple",
  components: {
    apexchart: VueApexCharts
  },
  props: ["series"],
  data() {
    return {
      chartType: "line",
      options: ApexchartHelper.settings("sp-simple", false)
    };
  }
};
</script>
